export enum PersonaTypes {
  VISITOR = 10,
  VIP = 15,
  GENERIC = 100,
  GROUP = 30,
  MEMBER = 31
}
